import { createContext } from 'react';

export const CtaBannerContext = createContext<() => void>(() => undefined);
